import React from 'react';
import styled from 'styled-components';
import { defineMessages, useIntl } from 'react-intl';
import CCModal from 'components/shared/DesignSystem/CCModal/CCModal';
import { Text } from '@companycam/slab-web';

type RestrictedFeatureModalProps = {
  onRequestClose: () => void;
};

const messages = defineMessages({
  modalTitle: {
    id: 'Projects.show.collaborationRow.restrictedFeatureModal.title',
    defaultMessage: "Sorry, you don't have permission to access that.",
    description: 'Title for the restricted feature modal',
  },
  content: {
    id: 'Projects.show.collaborationRow.restrictedFeatureModal.content',
    defaultMessage:
      'You do not have the required permissions to view Collaborator information. Please contact your system administrator for assistance.',
    description: 'Content for the restricted feature modal',
  },
  confirm: {
    id: 'Projects.show.collaborationRow.restrictedFeatureModal.confirm',
    defaultMessage: 'OK',
    description: 'Confirm button text for the restricted feature modal',
  },
});

const Title = styled.div`
  display: inline-block;
  font-size: var(--cc_size_text_l);
  font-weight: 800;
  white-space: nowrap;
`;

const RestrictedFeatureModal: React.FC<RestrictedFeatureModalProps> = ({
  onRequestClose,
}) => {
  const intl = useIntl();

  const primaryAction = {
    label: intl.formatMessage(messages.confirm),
    onClick: () => onRequestClose(),
    disabled: false,
  };

  const modalTitle = <Title>{intl.formatMessage(messages.modalTitle)}</Title>;

  return (
    <CCModal
      title={modalTitle}
      size="small"
      isOpen
      onRequestClose={onRequestClose}
      primaryAction={primaryAction}
    >
      <Text as="p">{intl.formatMessage(messages.content)}</Text>
    </CCModal>
  );
};

export default RestrictedFeatureModal;
